import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Fragment, onMounted, ref } from 'vue'
import { MdConfigProvider } from 'mdesign3'
import { ApaasWebSocketProvider, setProjectDataSource } from '@apaas/apaas-kit'
import { ApaasAuthProvider } from '@apaas/apaas-kit'
import scriptList from '@/assets/script.json'
import { asyncLoadRemoteScript, isBlank } from '@/utils'
import { RouterView } from 'vue-router'
import dataSources from '@/assets/dataSource.json'
import { useRouter } from 'vue-router'
import { isString } from 'lodash-es'

// 子应用内部跳转时，通知侧边栏改变菜单状态

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {

const onRouteChange = () => {
  if (window.__MICRO_APP_ENVIRONMENT__) {
    // 发送全局数据，通知侧边栏修改菜单展示
    window.microApp.setGlobalData({ name: window.__MICRO_APP_NAME__ })
  }
}

const nodeRedUrl = process.env.VUE_APP_PROXY_NODE_RED
const enableLogin = process.env.VUE_APP_ENABLE_LOGIN === 'true'
const router = useRouter()

// 路由切换时，切换标题
router.afterEach(to => {
  const { pageName } = to.meta
  if (!isBlank(pageName) && isString(pageName)) {
    document.title = pageName
  } else {
    document.title = process.env.VUE_APP_PROJECT_NAME as string
  }
})

const scriptLoaded = ref(false)
onMounted(async () => {
  // 加载脚本
  for (const item of scriptList) {
    await asyncLoadRemoteScript(item.url)
  }
  scriptLoaded.value = true
})

// 设置数据源
setProjectDataSource(dataSources)

__expose({
  onRouteChange
})

const ApaasWebSocketProviderChildren = () => {
  return (
    <Fragment>
      {!isBlank(nodeRedUrl) ? <ApaasWebSocketProvider url={nodeRedUrl}>
        <ApaasAuthProviderChildren />
      </ApaasWebSocketProvider> : <ApaasAuthProviderChildren />}
    </Fragment>
  )
}

const ApaasAuthProviderChildren = () => {
  return (
    <Fragment>
      {enableLogin ? <ApaasAuthProvider>
        <RouterView />
      </ApaasAuthProvider> : <RouterView />}
    </Fragment>
  )
}

return (_ctx: any,_cache: any) => {
  return (scriptLoaded.value)
    ? (_openBlock(), _createBlock(_unref(MdConfigProvider), {
        key: 0,
        namespace: "apaas-md"
      }, {
        default: _withCtx(() => [
          _createVNode(ApaasWebSocketProviderChildren)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})